import React from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  leftIcon?: React.ReactNode;
}
export function Input({
  label,
  error,
  leftIcon,
  className = '',
  ...props
}: InputProps) {
  return <div className="w-full" data-id="element-88">
      {label && <label className="block text-sm font-medium text-gray-700 mb-1.5" data-id="element-89">
          {label}
        </label>}
      <div className="relative" data-id="element-90">
        {leftIcon && <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-400" data-id="element-91">
            {leftIcon}
          </div>}
        <input className={`
            block w-full rounded-xl border-gray-200 shadow-sm
            focus:border-[#00B4A0] focus:ring-[#00B4A0] sm:text-sm py-3
            ${leftIcon ? 'pl-10' : 'pl-4'}
            ${error ? 'border-red-300 focus:border-red-500 focus:ring-red-500' : ''}
            ${className}
          `} {...props} data-id="element-92" />
      </div>
      {error && <p className="mt-1 text-sm text-red-600" data-id="element-93">{error}</p>}
    </div>;
}